import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaborUtilizationReportComponent } from './labor-utilization-report.component';

import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
} from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from 'src/app/core/material';
import { HttpClientModule } from '@angular/common/http';
import { LaborUtilizationReportRoutingModule } from './labor-utilization-report-routing.module';
import { ListLaborUtilizationReportModule } from './list-labor-utilization-report/list-labor-utilization-report.module';
import { AddLaborUtilizationReportModule } from './add-labor-utilization-report/add-labor-utilization-report.module';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import {NzSelectModule} from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ConfigHdldComponent } from './config-hdld/config-hdld.component';
import { ListLaborUtilizationReportComponent } from './list-labor-utilization-report/list-labor-utilization-report.component';

@NgModule({
  declarations: [LaborUtilizationReportComponent, ConfigHdldComponent, ListLaborUtilizationReportComponent],
  imports: [
    CommonModule,
    LaborUtilizationReportRoutingModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MaterialModule,
    MatSortModule,
    MatTableModule,
    HttpClientModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTabsModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    NgZorroAntdModule,
    NzSelectModule,
    NzFormModule,
    ListLaborUtilizationReportModule,
    AddLaborUtilizationReportModule,
  ],
  exports: [
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatButtonModule,
    NzSelectModule,
    NzFormModule
  ],
})
export class LaborUtilizationReportModule { }
